import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=1e1f4080&scoped=true&"
import script from "./TokenList.vue?vue&type=script&lang=ts&"
export * from "./TokenList.vue?vue&type=script&lang=ts&"
import style0 from "./TokenList.vue?vue&type=style&index=0&id=1e1f4080&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1f4080",
  null
  
)

export default component.exports